import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container container--small" }
const _hoisted_2 = { class: "highlights__header" }
const _hoisted_3 = { class: "container highlights__container" }
const _hoisted_4 = {
  key: 0,
  class: "highlights__btn-box"
}

import { computed } from 'vue'

import HighlightsList from '@/app/components/doc/highlights/HighlightsList.vue'
import ExportHighlightsButton from '@/app/components/book/highlights/ExportHighlightsButton.vue'

import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'Highlights',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const hasHighlights = computed(() => {
  return props.doc.highlights.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["highlights details-content", hasHighlights.value || 'highlights--empty'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "highlights__title" }, "Highlights, notes and bookmarks", -1)),
        _createVNode(ExportHighlightsButton, { class: "highlights__button" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HighlightsList, {
          doc: __props.doc,
          limit: 2,
          hideButtonOnMobile: true
        }, null, 8, ["doc"]),
        (hasHighlights.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: {
              name: __props.doc.routeNames().highlights,
              params: { url_slug: __props.doc.url_slug },
            },
                class: "highlights__button highlights__view-all btn-outline-primary btns--white book-unit__btn btns btns--small btns--full"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "Show all highlights", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})